import { Regex } from './Regex';

export const validateString = (value: string) => {
  const re = new RegExp(Regex.stringWithoutSpaceAndWithSpecialCharacter);
  return re.test(value);
};
export const validateString50Positions = (value: string) => {
  const re = new RegExp(Regex.string50WithoutSpaceAndWithSpecialCharacter);
  return re.test(value);
};

export const validateDate = (value: string) => {
  const re = new RegExp(Regex.date);
  return re.test(value);
};

export const validateTime = (value: string) => {
  const re = new RegExp(Regex.time);
  return re.test(value);
};

export const validatePhone = (value: string) => {
  const re = new RegExp(Regex.phone);
  return re.test(value);
};

export const validateCellPhone = (value: string) => {
  const re = new RegExp(Regex.cellPhone);
  return re.test(value);
};

export const validateLada = (value: string) => {
  const re = new RegExp(Regex.lada);
  return re.test(value);
};

export const validateExt = (value: string) => {
  const re = new RegExp(Regex.ext);
  return re.test(value);
};

export const validateEmail = (value: string) => {
  const re = new RegExp(Regex.email);
  return re.test(value);
};

export const validateRfc = (value: string) => {
  const re = new RegExp(Regex.rfc);
  return re.test(value);
};

export const validateZipCode = (value: string) => {
  const re = new RegExp(Regex.zipCode);
  return re.test(value);
};

export const validateStreet = (value: string) => {
  const re = new RegExp(Regex.street);
  return re.test(value);
};

export const validateAddressInformation = (value: string) => {
  const re = new RegExp(Regex.address);
  return re.test(value);
};

export const validateAddressInternalNumber = (value: string) => {
  const re = new RegExp(Regex.internalNumber);
  return re.test(value);
};

export const validateCLABE = (value: string) => {
  const re = new RegExp(Regex.CLABE);
  return re.test(value);
};
